import * as React from "react";
import { forwardRef } from "react";
const SvgQuantityCheck = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 40, viewBox: "0 0 24 24", fill: "none", stroke: "#4d4d4d", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round", className: "lucide lucide-grid2x2-check-icon lucide-grid-2x2-check", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M12 3v17a1 1 0 0 1-1 1H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v6a1 1 0 0 1-1 1H3" }), /* @__PURE__ */ React.createElement("path", { d: "m16 19 2 2 4-4" }));
const ForwardRef = forwardRef(SvgQuantityCheck);
export { ForwardRef as ReactComponent };
